import { render } from "./WeekStrip.vue?vue&type=template&id=79939536&scoped=true"
import script from "./WeekStrip.vue?vue&type=script&lang=js"
export * from "./WeekStrip.vue?vue&type=script&lang=js"

import "./WeekStrip.vue?vue&type=style&index=0&id=79939536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79939536"]])

export default __exports__